import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/redux/hooks";
import {
  resetMySiteGalleryStatus,
  resetMySitePhoneStatus,
  resetMySitePhotoStatus,
  resetMySiteSliderStatus,
  resetMySiteSocialMediaStatus,
  resetMySiteTextStatus,
  resetMySiteVideoStatus,
  resetRemoveWebsitePartitionStatus,
  selectMySiteGalleryStatus,
  selectMySitePhoneStatus,
  selectMySitePhotoStatus,
  selectMySiteSliderStatus,
  selectMySiteSocialMediaStatus,
  selectMySiteTextStatus,
  selectMySiteVideoStatus,
  selectRemovedWebsitePartitionStatus,
} from "../../../slices/mySiteSlice";
import { toast } from "react-toastify";
import { ApiStatus } from "../../../models/app/apiStatus";
import { useTranslation } from "react-i18next";

const useNotificationMessagessEffect = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const mySitePartitionsStatus = {
    photo: useAppSelector(selectMySitePhotoStatus),
    phone: useAppSelector(selectMySitePhoneStatus),
    text: useAppSelector(selectMySiteTextStatus),
    video: useAppSelector(selectMySiteVideoStatus),
    socialMedia: useAppSelector(selectMySiteSocialMediaStatus),
    gallery: useAppSelector(selectMySiteGalleryStatus),
    slider: useAppSelector(selectMySiteSliderStatus),
    removePartition: useAppSelector(selectRemovedWebsitePartitionStatus),
  };
  useEffect(() => {
    if (mySitePartitionsStatus.text === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessageText"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteTextStatus());
        },
      });
    } else if (mySitePartitionsStatus.phone === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessagePhone"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySitePhoneStatus());
        },
      });
    } else if (mySitePartitionsStatus.photo === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessagePhoto"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySitePhotoStatus());
        },
      });
    } else if (mySitePartitionsStatus.video === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessageVideo"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteVideoStatus());
        },
      });
    } else if (mySitePartitionsStatus.socialMedia === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessageSocialMedia"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteSocialMediaStatus());
        },
      });
    } else if (mySitePartitionsStatus.gallery === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessageGallery"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteGalleryStatus());
        },
      });
    } else if (mySitePartitionsStatus.slider === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessageSlider"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetMySiteSliderStatus());
        },
      });
    } else if (mySitePartitionsStatus.removePartition === ApiStatus.Fulfilled) {
      toast.success(t("mySite.mySiteSuccessMessagePartition"), {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: true,
        onClose: () => {
          dispatch(resetRemoveWebsitePartitionStatus());
        },
      });
    }
  }, [
    mySitePartitionsStatus.text,
    mySitePartitionsStatus.phone,
    mySitePartitionsStatus.photo,
    mySitePartitionsStatus.video,
    mySitePartitionsStatus.socialMedia,
    mySitePartitionsStatus.gallery,
    mySitePartitionsStatus.slider,
    mySitePartitionsStatus.removePartition,
  ]);
};

export default useNotificationMessagessEffect;
